module.exports = __webpack_public_path__ + "img/place_alpkgy.869e3fdc.png";